import React from 'react'
import { useBoSizeClass } from '@components/systems/backoffice/useBoSizeClass'
import { GridDesktop, GridProps } from './GridTable'
import { GridCardList } from './GridCardList'

/**
 * 공용 그리드 — 공개 props 는 그대로, 폭 등급으로 렌더러를 고른다 (RESPONSIVE_PLAN §5.1).
 * 데스크톱(≥1200) = DataGrid + 페이지네이션(불변) · 폰·태블릿 = 카드 목록 + 스크롤 이어 붙이기.
 * 두 렌더러를 동시에 마운트하지 않는다 — 45열 표를 숨겨 두고 그리는 짓은 하지 않는다.
 */
export const Grid = (props: GridProps) => {
	const sizeClass = useBoSizeClass()
	if (sizeClass === 'desktop') return <GridDesktop {...props} />
	return <GridCardList {...props} sizeClass={sizeClass} />
}
